import {
  BibliographyContentCreateRequest,
  BibliographyContentCreateRequestToJSON
} from '@/api/models/bibliography/BibliographyContentCreateRequest'
import {
  BibliographyContentUpdateRequest,
  BibliographyContentUpdateRequestToJSON
} from '@/api/models/bibliography/BibliographyContentUpdateRequest'
import {
  BibliographyContentDetail,
  BibliographyContentDetailFromJSON,
  BibliographyContentSortOrderUpdateRequest,
  BibliographyContentSortOrderUpdateRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class BibliographyContentApi extends runtime.BaseAPI {
  /**
   * 書誌情報を取得する
   * 書誌情報取得
   */
  async getById(id: number): Promise<BibliographyContentDetail> {
    const response = await this.requestGet(`/bibliographies-content/${id}`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      BibliographyContentDetailFromJSON(jsonValue)
    ).value()
  }

  async create(request: BibliographyContentCreateRequest): Promise<number> {
    const bodyParameters: runtime.HTTPBody = BibliographyContentCreateRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/bibliographies-content',
      bodyParameters
    )

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.bibliography_id
    ).value()
  }

  async update(
    id: number,
    request: BibliographyContentUpdateRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = BibliographyContentUpdateRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/bibliographies-content/${id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async delete(id: number, revision: number): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = {
      id,
      revision
    }
    const response = await this.requestDelete(
      `/bibliographies-content/${id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async updateSortOrder(
    request: BibliographyContentSortOrderUpdateRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = BibliographyContentSortOrderUpdateRequestToJSON(
      request
    )

    const response = await this.requestPut(
      `/bibliographies-content/sort-order`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
